import moment from "moment";

import { TimeRange } from "../domains/accounting-transaction/search/timerange";

interface TransactionSearchManager {
  setTimeRange: (timeRange: TimeRange, dates: [moment.Moment, moment.Moment]) => void;
}

export const getPeriod = (type: "previous" | "next", date: moment.Moment) => {
  let newStartDate, newEndDate;

  if (type === "previous") {
    newEndDate = moment(date).subtract(1, "second");
    newStartDate = moment(newEndDate).subtract(3, "months").subtract(1, "hour").add(1, "second");
  } else if (type === "next") {
    newStartDate = moment(date).add(1, "second");
    newEndDate = moment(newStartDate).add(3, "months").add(1, "hour");
  }

  return {
    startDate: newStartDate,
    endDate: newEndDate,
  };
};

export const fetchPeriod = (
  type: "previous" | "next",
  startDate: moment.Moment,
  endDate: moment.Moment,
  transactionSearchManager: TransactionSearchManager,
) => {
  let newStartDate, newEndDate;

  if (type === "previous") {
    const { startDate: tmpStartDate, endDate: tmpNewEndDate } = getPeriod(type, startDate);
    newStartDate = tmpStartDate;
    newEndDate = tmpNewEndDate;
  } else if (type === "next") {
    const { startDate: tmpStartDate, endDate: tmpNewEndDate } = getPeriod(type, endDate);
    newStartDate = tmpStartDate;
    newEndDate = tmpNewEndDate;
  }

  transactionSearchManager.setTimeRange(TimeRange.Other, [newStartDate, newEndDate]);
};
